export class URLEncoder {
  private static readonly SECRET = "gz-secret";

  private static xorString(input: string, secret: string): string {
    return [...input]
      .map((char, i) =>
        String.fromCharCode(char.charCodeAt(0) ^ secret.charCodeAt(i % secret.length))
      )
      .join('');
  }

  static encode(value: string | number): string {
    const str = String(value); // normalize number → string
    return btoa(this.xorString(str, this.SECRET));
  }

  static decode(token: string): string {
    return this.xorString(atob(token), this.SECRET);
  }
}
